import React, {Fragment} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {isLoggedIn} from '../Utils';
import {checksessiontime, getToken} from "../Utils/Common";
import MenuComponent from "../Components/Common/MenuComponent";


/**
 * @description determine if an array contains one or more items from another array.
 * @param {array} haystack the array to search.
 * @param {array} arr the array providing items to check for in the haystack.
 * @return {boolean} true|false if haystack contains at least one item from arr.
 */
const validateRole = (allowedRoles, actualRoles) => {
    return actualRoles.some(v => allowedRoles.includes(v));
};


/*
    Private Routes are accessible only with Handwai credentials :/ .
 */

function PrivateRoutes(props) {
    let allowedRoles = props.allowedRoles
    checksessiontime();
    let actualRoles = JSON.parse(sessionStorage.getItem("roles"))
    let rsl = validateRole(allowedRoles, actualRoles)
    const {component: Component, ...rest} = props;
    const render = (tmp_props) => {
        if (!(isLoggedIn() && getToken())) {
            return <Redirect to={process.env.REACT_APP_FRONTEND_PATH_LOGIN}/>;
        }
        if (rsl) {
            return (<Fragment>
                <MenuComponent/>
                <Component load={true} {...tmp_props} />
            </Fragment>)
        } else {
            <Redirect to={process.env.REACT_APP_FRONTEND_PATH_LOGIN}/>
        }
    };
    return <Route {...rest} render={render}/>;

}

export default PrivateRoutes;

// function PrivateRoutes(props) {
//     checksessiontime();
//     const { component: Component,...rest } = props;
//     const render = (tmp_props) => {
//         if (!(isLoggedIn() && getToken())) {
//             return <Redirect to={process.env.REACT_APP_FRONTEND_PATH_LOGIN} />;
//         }
//         return (
//         <Fragment>
//             <MenuComponent/>
//             <Component load={true} {...tmp_props} />
//         </Fragment>
//     );
//     };
//     return <Route {...rest} render={render} />;
//
// }
// export default PrivateRoutes;
